import { ISelectOption } from '../../ui-toolkit';

// Custom method to filter whether an option should be displayed in the menu.
// Pairs well with StatesLabelValue from ui-toolkit/enums/states.ts
export const stateFilterOptions = ({ value }: ISelectOption<string>, rawInput: string | null) =>
  value.toLowerCase().includes((rawInput || '').toLowerCase());
